import React from 'react';
import { motion } from 'framer-motion';
import { BalancesTable } from '../components/timeoff/BalancesTable';
import { OutList } from '../components/timeoff/OutList';
import { PoliciesList } from '../components/timeoff/PoliciesList';
import { RequestsQueue } from '../components/timeoff/RequestsQueue';
import { WhosOutCalendar } from '../components/timeoff/WhosOutCalendar';
import { PageHeader } from '../components/ui/PageHeader';
import type { Navigate, PtoRequest, TimeOffTab } from '../types/hr';
interface TimeOffProps {
  tab: TimeOffTab;
  requests: PtoRequest[];
  onDecide: (id: string, status: 'approved' | 'denied') => void;
  onNavigate: Navigate;
}
const TABS: {
  id: TimeOffTab;
  label: string;
}[] = [{
  id: 'whos-out',
  label: "Who's Out"
}, {
  id: 'requests',
  label: 'Requests'
}, {
  id: 'balances',
  label: 'Balances'
}, {
  id: 'policies',
  label: 'Policies'
}];
export function TimeOff({
  tab,
  requests,
  onDecide,
  onNavigate
}: TimeOffProps) {
  const pendingCount = requests.filter(r => r.status === 'pending').length;
  return <div data-id="element-1868" data-mp="3s7roixqed832">
      <PageHeader eyebrow="Time Off" title="Time off" description="Coverage, approvals, balances and the policies behind them." data-id="element-1869" data-mp="v6p4akfrjih" />

      <div className="mb-6 flex gap-1 overflow-x-auto rounded-2xl bg-white p-1.5 shadow-soft ring-1 ring-slate-900/[0.04] sm:inline-flex" role="tablist" aria-label="Time off sections" data-id="element-1870" data-mp="3j9z5pjlgviax">
        {TABS.map(t => {
        const active = t.id === tab;
        return <button key={t.id} type="button" role="tab" aria-selected={active} onClick={() => onNavigate({
          page: 'timeoff',
          tab: t.id
        })} className={`relative flex items-center gap-2 whitespace-nowrap rounded-xl px-4 py-2 text-sm font-medium transition ${active ? 'text-white' : 'text-slate-600 hover:text-navy'}`} data-id="element-1871" data-mp="ju2lnsjro9zh">
              {active && <motion.span layoutId="timeoff-tab" className="absolute inset-0 rounded-xl bg-navy" transition={{
            type: 'spring',
            bounce: 0.15,
            duration: 0.4
          }} data-id="element-1872" data-mp="2vjvcm65wn0y6" />}
              <span className="relative" data-id="element-1873" data-mp="1157qsq6vzmpl">{t.label}</span>
              {t.id === 'requests' && pendingCount > 0 && <span className="relative flex h-5 min-w-[20px] items-center justify-center rounded-full bg-flame px-1.5 text-[11px] font-semibold text-white" data-id="element-1874" data-mp="rdbthhcmk0mf">{pendingCount}</span>}
            </button>;
      })}
      </div>

      {tab === 'whos-out' && <div className="space-y-6" data-id="element-1875" data-mp="iaj2zgb9nsxn">
          <WhosOutCalendar requests={requests} onNavigate={onNavigate} data-id="element-1876" data-mp="ddj2rm13lkeg" />
          <OutList onNavigate={onNavigate} data-id="element-1877" data-mp="8efza60rnm8l" />
        </div>}
      {tab === 'requests' && <RequestsQueue requests={requests} onDecide={onDecide} onNavigate={onNavigate} data-id="element-1878" data-mp="4d45rperugv4" />}
      {tab === 'balances' && <BalancesTable onNavigate={onNavigate} data-id="element-1879" data-mp="22sgxcoohs57m" />}
      {tab === 'policies' && <PoliciesList onNavigate={onNavigate} data-id="element-1880" data-mp="22qmkzyradlf5" />}
    </div>;
}